import type { SxProps, Theme } from '@mui/material'

export const styles = {
  toggle: {
    p: 0.5,
    '& .MuiSvgIcon-root': { fontSize: 20 },
  },
  toggleActive: {
    background: (theme: Theme) => theme.palette.primary.relatedLight,
  },
} satisfies Record<string, SxProps<Theme>>
